import { Injectable } from '@angular/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ExportComponent } from '../components/export/export.component';
import { Observable } from 'rxjs';
import { data } from 'jquery';

@Injectable({
  providedIn: 'root'
})
export class ExportService {
  exportToExcel(data: any[], allColumns: any[], fileName: string) {
    throw new Error('Method not implemented.');
  }
  private ref!: DynamicDialogRef;
  constructor(public dialogService: DialogService) {}

  openExportDialog(selectedData: any[], columns: any[], fileName:any, allRecords:any[], exportApi:any, exportParams:any): Observable<any> {
    console.log(allRecords)
    this.ref = this.dialogService.open(ExportComponent, {
      header: 'Export',
      data: {
        selectedRows: selectedData,
        allColumns: columns,
        fileName: fileName,
        allRecords: allRecords,
        exportApi: exportApi,
        exportParams: exportParams
      },
      width: '35vw',
      contentStyle: { overflow: 'auto', position: 'top' },
      draggable: true
    });
    return this.ref.onClose; 
  }
  openInvoiceLineItemExportDialog(selectedData: any[], columns: any[], fileName:any, allRecords:any[], exportApi:any, exportParams:any, includeLineItems: Boolean): Observable<any> {
    console.log(allRecords)
    this.ref = this.dialogService.open(ExportComponent, {
      header: 'Export',
      data: {
        selectedRows: selectedData,
        allColumns: columns,
        fileName: fileName,
        allRecords: allRecords,
        exportApi: exportApi,
        exportParams: exportParams, 
        includeLineItems: includeLineItems
      },
      width: '35vw',
      contentStyle: { overflow: 'auto', position: 'top' },
      draggable: true
    });
    return this.ref.onClose; 
  }
}
